import Api from "./Api";
import store from "../state/store";

export default {
  getTimeRports(params) {
    return Api().get(
      `/visit_list_refactor/${store.getters["authfack/currentEntity"].id}`,
      {
        params: {
          filterBy:
            Object.keys(store.getters["grid/getFilterValues"]).length > 0
              ? store.getters["grid/getFilterValues"]
              : {},
          orderBy:
            params && params.orderBy
              ? params && params.orderBy
              : { sortField: null },
          limit: params && params.limit ? params && params.limit : 10,
          page: params && params.page ? params && params.page : 1,
        },
      }
    );
  },
  getHistoryRports(params) {
    const queryParams = {
      filterBy: params && params.finalFilterObject ? params.finalFilterObject : {},
      orderBy: params && params.sortObject ? params.sortObject : { sortField: null },
      limit: params && params.limit ? params && params.limit : 10,
      page: params && params.page ? params && params.page : 1,
    };
    if (params && params.isExporting) queryParams.isExporting = true;
    return Api().get(
      `/report_list_history/${store.getters["authfack/currentEntity"].id}`,
      {
        params: queryParams,
      }
    );
  },
  getTrackTrace(params) {
    return Api().get(
      `/track_and_trace/${store.getters["authfack/currentEntity"].id}`,
      {
        params: {
          user_id: params.id,
          date: params.date,
        },
      }
    );
  },
  getUsers() {
    return Api().get(
      `users/entities/${store.getters["authfack/currentEntity"].id}`
    );
  },
  getUsersNotOnSite(params) {
    return Api().get('get_users_not_on_site', params);
  },
  getPrintsData() {
    return Api().get(`print_queue_list/${store.getters["authfack/currentEntity"].id}`)
  },
  reprintRfid(print_queue_id) {
    return Api().put(`cancel_print/${print_queue_id}`)
  },
  cancelRfidPrint(print_queue_id) {
    return Api().put(`reprint/${print_queue_id}`)
  }
};
